import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation updateAnnouncement($groupPostId: String!, $title: String!, $body: String, $scheduledDate: String ) {
    updateAnnouncement(groupPostId: $groupPostId, title: $title, body: $body, scheduledDate: $scheduledDate) {
      success
      message
    }
  }
`

export interface UpdateAnnouncementInput {
  groupPostId: string
  title: string
  body?: string
  scheduledDate?: string
}

export interface UpdateAnnouncementOutput {
  updateAnnouncement: {
    success: boolean
    message: string
  }
}

export const useUpdateAnnouncement = () => useMutation<UpdateAnnouncementOutput, UpdateAnnouncementInput>(mutation)
